import {
  Card,
  Grid,
  Col,
  CardBody,
  Modal,
  CardHeader,
  CardTitle,
  IconButton,
  InfoBox,
  CardActions,
  Button,
} from "capitalroadkit";
import Tooltip from "@material-ui/core/Tooltip";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { faCloudUploadAlt } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import useAPI from "../../../../../hooks/useAPI";
import {
  checkAttachmentExistsAxios,
  uploadAttachmentAxios
} from "../../../api/CorporateActionsResource";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";


const UploadModal = ({ corporateAction, setCorporateAction, useIcon, accept = "", onClose }) => {
  const [open, setOpen] = useState(false);
  const [formDataToSend, setFormDataToSend] = useState(null); // FormData payload
  const [showSuccess, setShowSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);

  const uploadAPI = useAPI(uploadAttachmentAxios(corporateAction?.uuid), { immediate: false });


  useEffect(() => {
    if (formDataToSend) uploadAPI.fetch({}, formDataToSend);
  }, [formDataToSend]);


  useEffect(() => {
    const { response, loading, error } = uploadAPI;
    if (!loading) setFormDataToSend(null);
    if (response && !loading && !error) {
      setCorporateAction(response.data);
      setShowSuccess(true);
      if (onClose) onClose();
    }
  }, [uploadAPI.response, uploadAPI.loading, uploadAPI.error]);


  const schema = Yup.object().shape({
    file: Yup.mixed().required("Please choose a file"),
    description: Yup.string().max(1000, "Max 1000 characters"),
   // fileType: Yup.string().oneOf(["Generic", "Prospectus", "Announcement"]).required("Please choose a file type"),
  });

  const formik = useFormik({
    initialValues: { file: null, description: "", fileType: "" },
    validationSchema: schema,

    onSubmit: async (values, { resetForm }) => {
      const file = values.file;
      const fd = new FormData();
      fd.append("file", file);
      fd.append("description", values.description || "");

      try {
        const { data } = await checkAttachmentExistsAxios(corporateAction.uuid, file?.name)();
        if (data.exists) {
          setPendingFormData({ fd, resetForm });
          setShowConfirm(true);
          return;
        }
        setFormDataToSend(fd);
        resetForm();
      } catch (err) {
        console.error("Failed to check attachment existence", err);
        setFormDataToSend(fd);
      }
    }
  });

  const { values, errors, touched, setFieldValue } = formik;
  const loading = uploadAPI.loading;
  const error = uploadAPI.error;

  const handleClose = () => {
        setShowSuccess(false);
        setOpen(false);
        onClose && onClose(); //  trigger parent refresh
  };

  return (
    <>
      <Tooltip title="Upload attachment">
        <div style={{ display: "inline-block", marginLeft: useIcon ? "1rem" : "" }}>
          {useIcon ? (
            <FontAwesomeIcon
              icon={faCloudUploadAlt}
              onClick={() => setOpen(true)}
              style={{ cursor: "pointer" }}
            />
          ) : (
            <Button
              color="primary"
              variant="text"
              onClick={() => setOpen(true)}
              style={{ cursor: "pointer", marginLeft: "4px" }}
            >
              + Upload
            </Button>
          )}
        </div>
      </Tooltip>

      <Modal open={open} size={"xl"}>
        {open && (
          <Card>
            <CardHeader>
              <CardTitle>Attachments</CardTitle>
              <CardActions>
                  <IconButton icon={faTimes} onClick={handleClose} />
              </CardActions>
            </CardHeader>

            <CardBody>
              {!showSuccess ? (
                <>
              <FormikProvider value={formik}>
                <Form>
                  <Grid nested>
                    <Col sm={8}>
                      <input
                        type="file"
                        accept={accept}
                        onChange={(e) => setFieldValue("file", e.currentTarget.files?.[0] || null)}
                      />
                      {touched.file && errors.file && (
                        <div style={{ marginTop: 8 }}>
                          <InfoBox variant={InfoBox?.Variant.ERROR} value={errors.file} />
                        </div>
                      )}
                    </Col>
                  {
                    /* Storing type - is supported in the backend, but not required for this release.
                    *  Backend will default to generic support document.
                    * */
                    /*<Col sm={8} style={{ marginTop: "1rem" }}>
                      <label style={{ display: "block", marginBottom: 6 }}>File type</label>
                       business category select
                      <select
                        value={values.fileType}
                        onChange={(e) => setFieldValue("fileType", e.target.value)}
                        style={{ width: "100%", padding: "8px" }}
                      >
                        <option value="" disabled>
                          Select a type…
                        </option>
                        <option value="GENERIC_SUPPORTING_DOCUMENT">Generic Supporting Document</option>
                        <option value="PROSPECTUS">Prospectus</option>
                        <option value="ANNOUNCEMENT">Announcement</option>
                      </select>
                      {touched.fileType && errors.fileType && (
                        <div style={{ marginTop: 8 }}>
                          <InfoBox variant={InfoBox?.Variant.ERROR} value={errors.fileType} />
                        </div>
                      )}
                    </Col>*/
                  }

                    <Col sm={8} style={{ marginTop: "1rem" }}>
                      <textarea
                        rows={3}
                        placeholder="Description (optional)"
                        style={{ width: "100%" }}
                        value={values.description}
                        onChange={(e) => setFieldValue("description", e.target.value)}
                      />
                      {touched.description && errors.description && (
                        <div style={{ marginTop: 8 }}>
                          <InfoBox variant={InfoBox?.Variant.ERROR} value={errors.description} />
                        </div>
                      )}
                    </Col>

                    <Col sm={4} style={{ marginTop: "1rem" }}>
                      <Button color="primary" loading={loading} type="submit">
                        Upload
                      </Button>
                    </Col>
                  </Grid>
                </Form>
              </FormikProvider>

              <div
                style={{
                  marginTop: "16px",
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {error && <InfoBox variant={InfoBox?.Variant.ERROR} value={error.response?.data} />}
              </div>  </>
              ) : (
                <Grid nested>
                  <Col sm={12} style={{ textAlign: "center", marginTop: "1rem" }}>
                    <InfoBox
                      variant={InfoBox?.Variant.SUCCESS}
                      value="File uploaded successfully!"
                    />
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ marginTop: "1rem" }}
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </Col>
                </Grid>
              )}
            </CardBody>
          </Card>
        )}
      </Modal>

      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
        <DialogTitle>Replace existing file?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            A file with this name already exists for this corporate action. Do you want to replace it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirm(false)} color="secondary" variant="text">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setFormDataToSend(pendingFormData.fd);
              pendingFormData.resetForm();
              setPendingFormData(null);
              setShowConfirm(false);
            }}
            color="primary"
            variant="contained"
          >
            Replace
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default UploadModal;